import { render, staticRenderFns } from "./addOrderPaymentDialog.vue?vue&type=template&id=2c8f978a&"
import script from "./addOrderPaymentDialog.vue?vue&type=script&lang=js&"
export * from "./addOrderPaymentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports